import TitlePlans from "./plans/titlePlans";
import AdditionalFeatures from "./plans/additionalFeatues";
import TitlePlansMobile from "./plans-mobile/titlePlansMobile";
import AccordionComponentMobileFree from "./plans-mobile/planAccordionMobileFree";
import AccordionComponentMobilePremium from "./plans-mobile/planAccordionMobilePremium";
import ToggleButton from "src/components/general/toggleButton";
import { useState } from "react";
import AccordionComponentMobileUltimate from "./plans-mobile/planAccordionMobileUltimate";
import { SocialPlanAcordion } from "./plans/accordions/socialPlanAccordion";
import { WorkPlanAcordion } from "./plans/accordions/workPlanAccordion";

const toggleValue = [
  {
    text: "Free",
    value: "Free",
    imageSource: "",
    selectedImageSource: "",
  },
  {
    text: "Premium",
    value: "Premium",
    imageSource: "",
    selectedImageSource: "",
  },
  {
    text: "Ultimate",
    value: "Ultimate",
    imageSource: "",
    selectedImageSource: "",
  },
];

const Plans = () => {
  const [tabToggleValue, SetTabToggleValues] = useState("Free");

  const handleTabToggleChange = (value: any) => {
    SetTabToggleValues(value);
  };

  return (
    <>
      <div className="hidden flex-col sm:flex">
        <TitlePlans />
        <div className="flex w-full flex-col items-center justify-center">
          <SocialPlanAcordion />
          <div className="mt-5" />
          <WorkPlanAcordion />
        </div>
        <AdditionalFeatures />
      </div>
      <div className="flex flex-col sm:hidden">
        <TitlePlansMobile />
        <ToggleButton
          ToggleValues={toggleValue}
          DefaultValue={tabToggleValue}
          isTransparent={true}
          OnValueChange={handleTabToggleChange}
          buttonColor="data-[state=on]:text-blue-400"
        />
        {tabToggleValue === "Free" ? (
          <AccordionComponentMobileFree />
        ) : tabToggleValue === "Premium" ? (
          <AccordionComponentMobilePremium />
        ) : (
          <AccordionComponentMobileUltimate />
        )}
      </div>
    </>
  );
};

export default Plans;
